import React from "react";

import pdf from "@react-pdf/renderer";

import { colors } from "@/theme/overrides/colors";

const { Text, View, StyleSheet } = pdf;

const styles = StyleSheet.create({
  root: {
    width: "100%",
    marginTop: "12px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.dark,
    border: "none",
  },
  day: {
    fontWeight: 600,
    backgroundColor: "white",
    padding: "8px",
    fontSize: "14px",
  },
});

type Props = {
  day: string;
};
const Subheader: React.FC<Props> = ({ day = "Day 1" }) => {
  return (
    <View style={styles.root}>
      <Text style={styles.day}>{day}</Text>
    </View>
  );
};
export default Subheader;
